'use client'

import { XMarkIcon } from '@heroicons/react/24/solid'
import { Button } from '@sushiswap/ui'
import React, {
  type FC,
  useCallback,
  useMemo,
  useState,
  useTransition,
} from 'react'
import {
  usePoolFilters,
  useSetPoolFilters,
} from 'src/app/(networks)/_ui/pools-filters-provider'
import { SushiSwapCmsProtocols } from 'src/lib/constants'

export const TableFiltersResetButton: FC = () => {
  const [isPending, startTransition] = useTransition()
  const { protocols, tokenSymbols, farmsOnly } = usePoolFilters()
  const setFilters = useSetPoolFilters()

  const types = useMemo(
    () => (protocols.length === SushiSwapCmsProtocols.length ? [] : protocols),
    [protocols],
  )
  const [show, setShow] = useState(
    (types?.length ?? 0) + (tokenSymbols?.length ?? 0) > 0 || farmsOnly,
  )

  const reset = useCallback(() => {
    setShow(false)
    startTransition(() => {
      setFilters(undefined)
    })
  }, [setFilters])

  if (
    isPending
      ? show
      : (types?.length ?? 0) + (tokenSymbols?.length ?? 0) > 0 || farmsOnly
  ) {
    return (
      <Button
        onClick={reset}
        icon={XMarkIcon}
        iconPosition="end"
        variant="outline"
        size="sm"
      >
        Reset
      </Button>
    )
  }

  return null
}
